import { COLOR_TOKENS } from "./token";

export const INITIAL_COLOR = [
  COLOR_TOKENS.status.success[9],
  COLOR_TOKENS.status.warning[9],
  COLOR_TOKENS.status.error[9],
  COLOR_TOKENS.status.feature[9],
  COLOR_TOKENS.status.info[8],
  COLOR_TOKENS.pink[9],
  COLOR_TOKENS.plum[9],
  COLOR_TOKENS.lime[8],
  COLOR_TOKENS.jade[9],
  COLOR_TOKENS.amber[9],
  COLOR_TOKENS.brown[9],
  COLOR_TOKENS.gray[9],
];
